'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const StyledTabPane = styled__default.default.div `
  display: ${({ hide }) => (hide ? 'none' : 'flex')};
`;

exports.StyledTabPane = StyledTabPane;
//# sourceMappingURL=TabPane.styles.js.map
